import { reactive } from 'vue';
import BaseSetupService from '@/setup/BaseSetupService';
import { useAside, useTour } from '@orion.ui/orion';
import UnlockModuleAside from '@/components/unlock-module/UnlockModuleAside.vue';
import { SETTING_TYPE } from '@/typings/enums/SETTING_TYPE';
import { PLUGIN_TYPE } from '@/typings/enums/PLUGIN_TYPE';

type Props = SetupProps<typeof DashboardCompanySetupService.props>

export default class DashboardCompanySetupService extends BaseSetupService<Props> {
	static readonly props = undefined;

	private readonly state = reactive({
		stepTimer: 8000,
		showOrderMarketingCard: false,
		modelValue: this.self.isAgency() ? 'companyCode' : 'organization',
	});

	get stepTimer () { return this.state.stepTimer; }
	get modelValue () { return this.state.modelValue; }
	set modelValue (val) { this.state.modelValue = val; }

	get cardsLayoutClass () {
		return this.self.can('TimeTicketRead') ? 'col-lg-4' : 'col-lg-6';
	}

	constructor (props?: Props) {
		super(props);
	}

	protected async onBeforeMountAsync () {
		if (this.route.query.tour) {
			useTour('archiveReleaseNote').start();
		}

		this.state.showOrderMarketingCard = await this.self.getUserSettingAsync(SETTING_TYPE.ShowOrderMarketingCard);
	}

	async updateShowOrderMarketingSettingAsync (value: boolean) {
		await this.self.updateUserSettingAsync({
			settingType: SETTING_TYPE.ShowOrderMarketingCard,
			value,
		});
		this.state.showOrderMarketingCard = true;
	}

	createOrder () {
		this.router.push({
			name: 'Order',
			query: { create: 'true' },
		});
	}

	openUnlockOrderAside () {
		useAside({
			Nested: UnlockModuleAside,
			NestedProps: { type: PLUGIN_TYPE.Order },
			size: 'lg',
		});
	}
}
